import React from 'react'
import { updateObject } from 'helpers/objectHelpers'
import FormLanguage from 'components/forms/FormLanguage'
import TextTagsSelector from 'components/forms/TextTagsSelector'

const TextContent = ({
  valueContent,
  valueContent: {
    text = {},
  },
  onChangeContent,
  valueSettings,
  valueSettings: {
    as = {},
  },
  onChangeSettings,
  style,
}) => {
  const handleChangeContent = (val, key) => {
    return onChangeContent(updateObject(valueContent, { [key]: val }))
  }
  const handleChangeSettings = (val, key) => {
    return onChangeSettings(updateObject(valueSettings, { [key]: val }))
  }
  return (
    <div style={style}>
      <FormLanguage.Textarea
        value={text}
        rowsMax={20}
        onChange={(val) => handleChangeContent(val, 'text')}
      />
      <TextTagsSelector
        value={as}
        onChange={(val) => handleChangeSettings(val, 'as')}
      />
    </div>
  )
}

TextContent.propTypes = {}
TextContent.defaultProps = {}

export default TextContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/text/TextContent.js